import script from "./OrderTicketsGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderTicketsGroup.vue?vue&type=script&setup=true&lang=js"

import "./OrderTicketsGroup.vue?vue&type=style&index=0&id=4b904649&lang=scss"

const __exports__ = script;

export default __exports__